import { render, staticRenderFns } from "./ResultTagAdd.vue?vue&type=template&id=6d637760&"
import script from "./ResultTagAdd.vue?vue&type=script&lang=js&"
export * from "./ResultTagAdd.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/libs/vue-color/vue-color.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports